module.exports = __webpack_public_path__ + "img/biznis.8d6411b5.png";